import { consoleEvents } from '@pb/utils'
import { createReducer } from 'redux-act'

import * as actions from './actions'
import initialState from './initialState'

const fetchClubJoinBannerStart = (state): any => ({
  ...state,
  isClubJoinBannerLoading: true,
})

const fetchClubJoinBannerSuccess = (state, payload): any => ({
  ...state,
  isClubJoinBannerLoading: false,
  clubJoinBanner: payload,
})

const fetchClubJoinBannerFail = (state, error): any => {
  consoleEvents.error('Failed to fetch Club Join Banner', error)

  return {
    ...state,
    isClubJoinBannerLoading: false,
  }
}

const setJoinClubModalVisibility = (state, payload): any => ({
  ...state,
  showJoinClubModal: payload,
})

const reducer = createReducer((on) => {
  on(actions.fetchClubJoinBannerStart, fetchClubJoinBannerStart)
  on(actions.fetchClubJoinBannerSuccess, fetchClubJoinBannerSuccess)
  on(actions.fetchClubJoinBannerFail, fetchClubJoinBannerFail)

  on(actions.setJoinClubModalVisibility, setJoinClubModalVisibility)
}, initialState)

export default reducer
